module.exports = __webpack_public_path__ + "img/08.d73713c9.png";